import React,{ useContext } from "react";
import "./SocialMedia.css";
import { socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/styleContext";

const SocialMedia = () => {
  
  const { isDark } = useContext(StyleContext); 

  return (
    <div className={!isDark ? 'social-media-div social-media-div-white' :'social-media-div'} >
      {socialMediaLinks.gmail ? (
        <div
          className="icon i-email"
          onClick={() => {
            window.open(`mailto:${socialMediaLinks.gmail}`);
          }}
        >
          <svg height={60} width={60}>
            <circle
              cx={30}
              cy={30}
              r={25}
              stroke={isDark ? "white" : "black"}
              strokeWidth="4"
              fill="none"
            ></circle>
          </svg>
          <i className="fas fa-envelope"></i>
        </div>
      ) : null}

      {/* {/* {socialMediaLinks.wt ? (
        <a
          href={socialMediaLinks.wt}
          className="icon-button whatsapp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-whatsapp	 icon"></i>
          <span></span>
        </a>
      ) : null} */}

      {socialMediaLinks.wt ? (
        <div
          className="icon i-whatsapp"
          onClick={() => {
            window.open(socialMediaLinks.wt);
          }}
        >
          <svg height={60} width={60}>
            <circle
              cx={30}
              cy={30}
              r={25}
              stroke={isDark ? "white" : "black"}
              strokeWidth="4"
              fill="none"
            ></circle>
          </svg>
          <i className="fab fa-whatsapp"></i>
        </div>
      ) : null}
      {socialMediaLinks.linkedin ? (
        <div
          className="icon i-linkedin"
          onClick={() => {
            window.open(socialMediaLinks.linkedin);
          }}
        >
          <svg height={60} width={60}>
            <circle
              cx={30}
              cy={30}
              r={25}
              stroke={isDark ? "white" : "black"}
              strokeWidth="4"
              fill="none"
            ></circle>
          </svg>
          <i className="fab fa-linkedin"></i>
        </div>
      ) : null}

      {socialMediaLinks.github ? (
        <div
          className="icon i-github"
          onClick={() => {
            window.open(socialMediaLinks.github);
          }}
        >
          <svg height={60} width={60}>
            <circle
              cx={30}
              cy={30}
              r={25}
              stroke={isDark ? "white" : "black"}
              strokeWidth="4"
              fill="none"
            ></circle>
          </svg>
          <i className="fab fa-github"></i>
        </div>
      ) : null}

      {socialMediaLinks.twitter ? (
        <div
          className="icon i-twitter"
          onClick={() => {
            window.open(socialMediaLinks.twitter);
          }}
        >
          <svg height={60} width={60}>
            <circle
              cx={30}
              cy={30}
              r={25}
              stroke={isDark ? "white" : "black"}
              strokeWidth="4"
              fill="none"
            ></circle>
          </svg>
          <i className="fab fa-twitter"></i>
        </div>
      ) : null}
    </div>
  );
};

export default SocialMedia;
